<script setup lang="ts">
// 1–5 stars as a radio group: arrow keys or 1–5 choose, each says what it
// means (Very Poor … Excellent), never color alone.
import { computed } from 'vue'
import { StarIcon } from '@/components/icons'

const props = defineProps<{ modelValue: number | null; label: string }>()
const emit = defineEmits<{ 'update:modelValue': [number] }>()
const LABELS = ['Very Poor', 'Poor', 'Okay', 'Good', 'Excellent']
const word = computed(() => (props.modelValue ? LABELS[props.modelValue - 1] : 'Not rated yet'))

function key(e: KeyboardEvent) {
  const cur = props.modelValue ?? 0
  if (e.key === 'ArrowRight' || e.key === 'ArrowUp') emit('update:modelValue', Math.min(5, cur + 1))
  else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') emit('update:modelValue', Math.max(1, cur - 1))
  else if (/^[1-5]$/.test(e.key)) emit('update:modelValue', Number(e.key))
  else return
  e.preventDefault()
}
</script>

<template>
  <div role="radiogroup" :aria-label="label" class="flex items-center gap-1" @keydown="key">
    <button
      v-for="n in 5"
      :key="n"
      type="button"
      role="radio"
      :aria-checked="modelValue === n"
      :aria-label="`${n} ${n === 1 ? 'star' : 'stars'}: ${LABELS[n - 1]}`"
      :tabindex="(modelValue ?? 1) === n ? 0 : -1"
      class="p-1 rounded-md"
      :class="(modelValue ?? 0) >= n ? 'text-warn' : 'text-fg-3 hover:text-fg-2'"
      @click="emit('update:modelValue', n)"
    >
      <StarIcon :size="22" :class="(modelValue ?? 0) >= n ? 'fill-current' : ''" />
    </button>
    <span class="ml-2 text-xs text-fg-2" aria-live="polite">{{ word }}</span>
  </div>
</template>
